import { ReactNode } from 'react';
import { Card, CardContent } from './ui/card';
import { Alert, AlertDescription } from './ui/alert';
import { Loader2 } from 'lucide-react';

interface EventsLoadingStatesProps {
  isLoading: boolean;
  error: unknown;
  eventsCount: number;
  children: ReactNode;
}

export const EventsLoadingStates = ({ isLoading, error, eventsCount, children }: EventsLoadingStatesProps) => {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="h-8 w-8 animate-spin text-[var(--color-secondary-500)]" />
        <span className="ml-3 text-[var(--color-neutral-700)]">Loading events...</span>
      </div>
    );
  }

  if (error) {
    return (
      <Alert className="bg-[var(--color-error-200)] border-[var(--color-error-700)]">
        <AlertDescription>Failed to load events. Please try again.</AlertDescription>
      </Alert>
    );
  }

  if (eventsCount === 0) {
    return (
      <Card className="bg-[var(--color-neutral-300)]/20">
        <CardContent className="py-8 text-center">
          <p className="text-[var(--color-neutral-700)]">No events available.</p>
        </CardContent>
      </Card>
    );
  }

  return <>{children}</>;
};
